import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AppSettings } from "../appsettings/appsettings";
import { map } from "rxjs/operators";
import { OidcSecurityService } from "angular-auth-oidc-client";

@Injectable()
export class DeviceService {
  constructor(
    private http: HttpClient,
    public oidcSecurityService: OidcSecurityService,
  ) {}

  public getDevices() {
    const header: HttpHeaders = new HttpHeaders()
      .append("Content-Type", "application/json; charset=UTF-8")
      .append("Authorization", "Bearer " + this.oidcSecurityService.getAccessToken());
    return this.http
      .get<any>(AppSettings.API_ENDPOINT + "/api/Devices", { headers: header })
      .pipe(
        map((device) => {
          return device;
        }),
      );
  }

  public updateMaintenance(orgId, hardwareId) {
    const header: HttpHeaders = new HttpHeaders()
      .append("Content-Type", "application/json; charset=UTF-8")
      .append("Authorization", "Bearer " + this.oidcSecurityService.getAccessToken());
    return this.http
      .get<any>(
        AppSettings.API_ENDPOINT +
          "/api/Organization/" +
          orgId +
          "/devices/" +
          hardwareId +
          "/maintenance",
        { headers: header },
      )
      .pipe(
        map((isTriggerMaintenanceEnabled) => {
          return isTriggerMaintenanceEnabled;
        }),
      );
  }

  /*  public getDeviceByCID(orgId: string) {
        const header: HttpHeaders = new HttpHeaders()
            .append('Content-Type', 'application/json; charset=UTF-8')
            .append('Authorization', 'Bearer ' + this.oidcSecurityService.getAccessToken());
        return this.http.get<any>(AppSettings.API_ENDPOINT + '/api/Devices/Organization/' + orgId + '/Devices', { headers: header })
            .pipe(map(device => {
                return device;
            }));
    }


    public getDeviceByHwid(hwid: string) {
        const header: HttpHeaders = new HttpHeaders()
        .append('Content-Type', 'application/json; charset=UTF-8')
        .append('Authorization', 'Bearer ' + this.oidcSecurityService.getAccessToken());
        return this.http.get(AppSettings.API_ENDPOINT  + '/api/Devices/' + hwid, { headers: header })
        .pipe(map(device => {
            return device;
        }));
    }

    public patchDevicesByHWID(HWID: string, name: string, description: string) {
        const header: HttpHeaders = new HttpHeaders()
            .append('Content-Type', 'application/json; charset=UTF-8')
            .append('Authorization', 'Bearer ' + this.oidcSecurityService.getAccessToken());
        const body = {
            deviceName: name,
            description
        };
        return this.http.put(AppSettings.API_ENDPOINT + '/api/Devices/' + HWID, body, { headers: header });
    }

    public registerDevice(HWID) {
        const header: HttpHeaders = new HttpHeaders()
            .append('Content-Type', 'application/json; charset=UTF-8')
            .append('Authorization', 'Bearer ' + this.oidcSecurityService.getAccessToken());
        const body = {
            hardwareId: HWID
        };
        return this.http.post(AppSettings.API_ENDPOINT + '/api/Devices/Registration', body, { headers: header });
    }

    public removeDevice(HWID) {
        const header: HttpHeaders = new HttpHeaders()
            .append('Content-Type', 'application/json; charset=UTF-8')
            .append('Authorization', 'Bearer ' + this.oidcSecurityService.getAccessToken());
        return this.http.delete(AppSettings.API_ENDPOINT + '/api/Devices/' + HWID, { headers: header });
    }


    public getDeviceSettings(hwid: string) {
        const header: HttpHeaders = new HttpHeaders()
        .append('Content-Type', 'application/json; charset=UTF-8')
        .append('Authorization', 'Bearer ' + this.oidcSecurityService.getAccessToken());
        return this.http.get<DeviceSettingsInterface>(AppSettings.API_ENDPOINT + '/api/Devices/' + hwid + '/Settings', {headers: header})
        .pipe(
            map(deviceSettings => {
                return deviceSettings;
            })
        );
    }

    public postDeviceSettings(hwid: string, settings: object) {
        const header: HttpHeaders = new HttpHeaders()
        .append('Content-Type', 'application/json; charset=UTF-8')
        .append('Authorization', 'Bearer ' + this.oidcSecurityService.getAccessToken());
        const body = settings;
        return this.http.post(AppSettings.API_ENDPOINT + '/api/Devices/' + hwid + '/Settings', body , { headers: header });
    }

    public getDeviceTemplates(orgId: string) {
        const header: HttpHeaders = new HttpHeaders()
        .append('Content-Type', 'application/json; charset=UTF-8')
        .append('Authorization', 'Bearer ' + this.oidcSecurityService.getAccessToken());
        return this.http.get(AppSettings.API_ENDPOINT + '/api/Organizations/' + orgId + '/Templates', {headers: header})
        .pipe(
            map(templates => {
                return templates;
            })
        );
    }

    public getDeviceTemplate(templateId: string) {
        const header: HttpHeaders = new HttpHeaders()
        .append('Content-Type', 'application/json; charset=UTF-8')
        .append('Authorization', 'Bearer ' + this.oidcSecurityService.getAccessToken());
        return this.http.get(AppSettings.API_ENDPOINT + '/api/Template/' + templateId, {headers: header})
        .pipe(
            map(template => {
                return template;
            })
        );
    }

    public postDeviceTemplate(orgId: string, template: object) {
        const header: HttpHeaders = new HttpHeaders()
        .append('Content-Type', 'application/json; charset=UTF-8')
        .append('Authorization', 'Bearer ' + this.oidcSecurityService.getAccessToken());
        const body = template;
        return this.http.post(AppSettings.API_ENDPOINT + '/api/Organizations/' + orgId + '/Templates', body, {headers: header});
    }

    public deleteDeviceTemplate(templateId: string) {
        const header: HttpHeaders = new HttpHeaders()
        .append('Content-Type', 'application/json; charset=UTF-8')
        .append('Authorization', 'Bearer ' + this.oidcSecurityService.getAccessToken());
        return this.http.delete(AppSettings.API_ENDPOINT + '/api/Template/' + templateId, {headers: header})
        .pipe();
    }

    public getDeviceAccount(hwid: string) {
        const header: HttpHeaders = new HttpHeaders()
        .append('Content-Type', 'application/json; charset=UTF-8')
        .append('Authorization', 'Bearer ' + this.oidcSecurityService.getAccessToken());
        return this.http.get<DeviceSettingsInterface>(AppSettings.API_ENDPOINT + '/api/Devices/' + hwid + '/Account', {headers: header})
        .pipe(
            map(deviceSettings => {
                return deviceSettings;
            })
        );
    }


    public postDeviceAccount(hwid: string, settings: object) {
        const header: HttpHeaders = new HttpHeaders()
        .append('Content-Type', 'application/json; charset=UTF-8')
        .append('Authorization', 'Bearer ' + this.oidcSecurityService.getAccessToken());
        const body = settings;
        return this.http.post(AppSettings.API_ENDPOINT + '/api/Devices/' + hwid + '/Account', body , { headers: header });
    }*/
}
